import React, { useState, useRef } from 'react'
import { FlexGrid, FlexGridColumn, FlexGridCellTemplate } from '@mescius/wijmo.react.grid'
import { SelectionMode } from '@mescius/wijmo.grid'
import { IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import StarRate from '@material-ui/icons/StarRate'

const useStyles = makeStyles((theme) => ({
  favoriteOn: {
    color: '#ffd700'
  },
  favoriteOff: {
    color: '#c0c0c0'
  }
}))

export default function WorkflowList (workflows, setSelectedId) {
  const classes = useStyles()
  const [favoredMap, setFavoredMap] = useState(new Map(workflows.map((wf) => [wf.id, wf.favored])))
  const csrfRef = useRef($('meta[name="csrf-token"]'))

  const renderFavoredCell = (_favoredMap) => function _ (ctx) {
    return (
      <IconButton
        className={_favoredMap.get(ctx.item.id) ? classes.favoriteOn : classes.favoriteOff}
        onClick={(e) => {
          $.ajax({
            url: ctx.item.favorite_url,
            type: 'POST',
            data: { _token: csrfRef.current.attr('content') }
          }).done((data) => {
            const _newFavoredMap = new Map(_favoredMap)
            _newFavoredMap.set(Number(data.id), Number(data.afterValue))
            setFavoredMap(_newFavoredMap)
            csrfRef.current.attr('content', data['csrf-token'])
            $('input[name="_token"]').val(data['csrf-token'])
          }).fail((jqXHR, textStatus, errorThrown) => {
            console.error(errorThrown)
          })
        }}>
        <StarRate></StarRate>
      </IconButton>
    )
  }

  return (
    <FlexGrid itemsSource={workflows} style={{ maxHeight: 500, width: '100%' }} selectionMode={SelectionMode.Row} isReadOnly={true}
      selectionChanged={(grid) => setSelectedId(grid.rows[grid.selection.row].dataItem.id)} >
      <FlexGridColumn header='No.' binding='id' width={40} cssClass='d-flex align-items-center justify-content-end' />
      <FlexGridColumn header=' ' width={60} align='center'>
        <FlexGridCellTemplate cellType='Cell' template={renderFavoredCell(favoredMap)} />
      </FlexGridColumn>
      <FlexGridColumn header='ルート名' binding='name' width={'*'} wordWrap={true} cssClass='d-flex align-items-center' />
      <FlexGridColumn header='説明' binding='comment' width={'*'} wordWrap={true} cssClass='d-flex align-items-center' />
      <FlexGridColumn header='グループ' binding='group.group_name' width={150} cssClass='d-flex align-items-center' />
    </FlexGrid>
  )
}
